
import {getListExchangeRates} from '../api/getListExchangeRates';
import {setGetListExchangeRatesAction} from '../action';

const setGetListExchangeRates = (params) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await getListExchangeRates(params);
            if (data.status === 'success') {
                dispatch(setGetListExchangeRatesAction(data.data));           
            }
    
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setGetListExchangeRates
}